class UploadContractsController {

    constructor(integrationApiService, messageService) {
        this.integrationApiService = integrationApiService;
        this.messageService = messageService;
    }

    $onInit () {

    }

    onSave () {
        this.messageService.clear();

        return this.integrationApiService.uploadContracts({ file: this.csv })
            .then(response => {
                this.csv = undefined;
                this.messageService.success('Success, contract details replaced');
                this.messageService.push();
            })
            .catch((error) => {
                this.messageService.failure(error);
                this.messageService.push();
            });
    }

}

UploadContractsController.$inject = ['integrationApiService', 'messageService'];

export default UploadContractsController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/dashboard/controllers/uploadContracts.controller.js